import { InviteLock } from "@/components/growth/InviteLock";
import { Link } from "react-router-dom";
import { Gamepad2, Gift } from "lucide-react";
import { GameArena, ArenaHeader } from "@/components/games/GameArena";
import { FunTiles } from "@/components/FunTiles";
import { DailyProgress } from "@/components/games/DailyProgress";
import { SkillTiles } from "@/components/skill/SkillTiles";
import { ComebackBanner } from "@/components/games/ComebackBanner";

export default function Games() {
  return (
    <GameArena>
    <div className="max-w-2xl mx-auto space-y-6 pb-20" data-testid="games-page">
      <ArenaHeader title="Spielen" sub="Tippe auf ein Spiel und leg los." icon={Gamepad2} />
      <InviteLock gate="games" />
      <InviteLock gate="luck" />
      <div className="arena-glass rounded-3xl p-4 sm:p-5 flex items-start gap-3" data-testid="games-intro">
        <span className="w-10 h-10 rounded-2xl bg-amber-100 flex items-center justify-center shrink-0"><Gift className="w-5 h-5 text-amber-600" /></span>
        <div className="min-w-0">
          <p className="text-sm sm:text-base font-semibold text-slate-800 leading-snug">Spiele Spiele, um Punkte zu sammeln, die du gegen <Link to="/geschenke" className="text-rose-600 underline underline-offset-2" data-testid="games-intro-rewards-link">tolle Prämien</Link> tauschen kannst.</p>
          <span className="mt-2 inline-flex items-center gap-1 px-2.5 h-6 rounded-full bg-emerald-50 text-emerald-700 text-xs font-extrabold" data-testid="games-intro-free">✓ Alles kostenlos</span>
        </div>
      </div>
      <ComebackBanner />
      <DailyProgress />
      <SkillTiles />
      <div><p className="arena-label mb-3">Alle Spiele & Aktionen</p><FunTiles /></div>
    </div>
    </GameArena>
  );
}
